var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      staticClass: "lpu-information d-flex flex-column",
      class: _setup.isMobile ? "ga-5" : "ga-8",
      attrs: { id: "information", "data-qa": "lpu_information" },
    },
    [
      _vm.lpu.lpu_photos?.length
        ? _c(_setup.LpuPhotos, {
            attrs: { photos: _vm.lpu.lpu_photos, "lpu-name": _vm.lpu.name },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "lpu-information__body",
          class: _setup.isMobile
            ? "d-flex flex-column ga-5"
            : "d-flex align-start ga-8",
        },
        [
          _c(_setup.InformationCard, {
            staticClass: "lpu-information__card",
            class: {
              "lpu-information__card--desktop": !_setup.isMobile,
              "order-1": _setup.isMobile,
            },
            attrs: { lpu: _vm.lpu, "license-items": _setup.licenseItems },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "lpu-information__content d-flex flex-column ga-5" },
            [
              _c(
                "h2",
                {
                  staticClass: "text--text",
                  class: _setup.isMobile ? "text-h6" : "text-h5",
                  attrs: { "data-qa": "lpu_information_title" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_setup.tStatic("Информация")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _setup.hasAmenities
                ? [
                    _setup.descriptionHtml
                      ? _c(_setup.InformationTextBlock, {
                          attrs: {
                            title: _setup.tStatic("Описание"),
                            html: _setup.descriptionHtml,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.servicesHtml
                      ? _c(_setup.InformationTextBlock, {
                          attrs: {
                            title: _setup.tStatic("Услуги"),
                            html: _setup.servicesHtml,
                          },
                        })
                      : _vm._e(),
                  ]
                : _c("p", { staticClass: "text-body-2 text--text ma-0" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_setup.tStatic("Нет описания")) +
                        ".\n      "
                    ),
                  ]),
              _vm._v(" "),
              _c(_setup.LpuMedals, { attrs: { lpu: _vm.lpu } }),
              _vm._v(" "),
              _setup.hasAmenities &&
              (_setup.transportHtml || _setup.parkingHtml)
                ? _c(
                    "div",
                    {
                      staticClass: "lpu-information__geo d-flex",
                      class: _setup.isMobile ? "flex-column ga-6" : "ga-6",
                    },
                    [
                      _setup.transportHtml
                        ? _c(_setup.InformationTextBlock, {
                            attrs: {
                              title: _setup.tStatic("Проезд"),
                              html: _setup.transportHtml,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _setup.parkingHtml
                        ? _c(_setup.InformationTextBlock, {
                            attrs: {
                              title: _setup.tStatic("Парковка"),
                              html: _setup.parkingHtml,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }